import React from "react";
import { motion } from "framer-motion";
import Lottie from "lottie-react";
import loader from "../astrnaute.json";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBriefcase,
  faLaptopCode,
  faRocket,
} from "@fortawesome/free-solid-svg-icons";

const experiences = [
  {
    title: "Frontend Developer Intern",
    company: "CodeClause",
    period: "3 Months",
    color: "#FACC15",
    icon: faLaptopCode,
  },
  {
    title: "Full Stack Developer",
    company: "Stalcon Solutions",
    period: "Jun 2024 – Jan 2025",
    color: "#3B82F6",
    icon: faBriefcase,
  },
  {
    title: "Software Engineer",
    company: "BlinksWorx",
    period: "Jan 2025 – Present",
    color: "#22C55E",
    icon: faRocket,
  },
];

export default function Experience() {
  const getMonthsSince = (date) => {
    const start = new Date(date);
    const now = new Date();
    return (
      (now.getFullYear() - start.getFullYear()) * 12 +
      (now.getMonth() - start.getMonth())
    );
  };

  const monthsWorked = getMonthsSince("2025-01-01");

  return (
    <section className="relative overflow-hidden bg-custombg py-24 px-6">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-24 -left-24 h-[450px] w-[450px] rounded-full bg-purple-500/20 blur-[120px]" />
        <div className="absolute -bottom-24 -right-24 h-[500px] w-[500px] rounded-full bg-blue-500/20 blur-[140px]" />
        <div className="absolute top-1/3 left-1/2 h-[320px] w-[320px] -translate-x-1/2 rounded-full bg-pink-500/20 blur-[120px]" />
        <div className="absolute top-20 right-1/4 h-[220px] w-[220px] rounded-full bg-cyan-400/20 blur-[100px]" />
      </div>

      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,.04)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.04)_1px,transparent_1px)] bg-[size:40px_40px]" />
      <div className="absolute inset-0 opacity-[0.03] bg-[url('https://grainy-gradients.vercel.app/noise.svg')]" />

      <div className="relative mx-auto max-w-7xl grid lg:grid-cols-2 gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl p-8"
        >
          <p className="uppercase tracking-[0.35em] text-yellow-400 font-semibold">
            Career Journey
          </p>

          <h2 className="mt-4 text-5xl font-bold text-white">
            Work <span className="text-yellow-400">Experience</span>
          </h2>

          <p className="mt-5 text-gray-400">
            Building scalable web and mobile products with modern technologies,
            clean architecture and production-ready solutions.
          </p>

          <div className="mt-10 h-[380px]">
            <Lottie animationData={loader} className="h-full w-full" />
          </div>
        </motion.div>

        <div className="space-y-6">
          {experiences.map((item, index) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -6 }}
              className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl p-6"
            >
              <div className="flex gap-5 items-start">
                <div
                  className="flex h-16 w-16 items-center justify-center rounded-2xl"
                  style={{
                    background: item.color + "20",
                    border: `1px solid ${item.color}55`,
                  }}
                >
                  <FontAwesomeIcon
                    icon={item.icon}
                    style={{ color: item.color }}
                    className="text-2xl"
                  />
                </div>

                <div className="flex-1">
                  <h3 className="text-2xl font-semibold text-white">
                    {item.title}
                  </h3>

                  <p className="mt-2 text-yellow-400">{item.company}</p>

                  <p className="mt-1 text-gray-400">
                    {item.company === "BlinksWorx"
                      ? `${item.period} (${monthsWorked}+ months)`
                      : item.period}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
